module.exports = __webpack_public_path__ + "static/media/farmer-garden-fork.cca3d230.png";